import React from 'react'
import { Spinner } from 'react-bootstrap';

const AppSpinner = () => {
  // const style = { position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
  const style = {
    position: "fixed",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    top: "0",
    left: "0",
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    zIndex: "9999"
  }
  return (
    <div style={style}>
      <Spinner animation="border" variant="primary" />
      <Spinner animation="grow" variant="success" />
      <Spinner animation="border" variant="danger" />
      <Spinner animation="grow" variant="warning" />
      <Spinner animation="border" variant="info" />
    </div>

  );
}

export default AppSpinner
